import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class CustomMailSettingI18nCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	public forReservation = createFeatureIslandCategoryStore({
		title: "予約：確定・変更・キャンセル",
		description: "",
		isBasicSetup: true,
	});

	public forCheckInRemind = createFeatureIslandCategoryStore({
		title: "チェックイン前：リマインド",
		description: "",
		isBasicSetup: true,
	});

	public forCheckOutRemind = createFeatureIslandCategoryStore({
		title: "チェックアウト後：ご案内",
		description: "",
		isBasicSetup: true,
	});

	public forRequestReservation = createFeatureIslandCategoryStore({
		title: "リクエスト予約",
		description: "",
		isBasicSetup: true,
	});

	public forShopping = createFeatureIslandCategoryStore({
		title: "宿泊券",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [
		this.forReservation,
		this.forCheckInRemind,
		this.forCheckOutRemind,
		this.forRequestReservation,
		this.forShopping,
	];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const customMailSettingI18nCategoriesAndManagerStore = new CustomMailSettingI18nCategoriesAndManagerStore();
